/* OUTDOER variant gallery filter v2.3
   Shows only the images matching the selected color.
   Match priority: image ALT text, then filename. Images with no color token show for every color.
   Fallback: if the selected color has NO tagged images at all, every image is shown.
   v2.3: mobile carousel pagination dots stay in sync with hidden slides. */
(() => {
  const stripDelim = (s) => (s || '').toString().toLowerCase().replace(/[-_.\s\/+()]/g, '');

  const filenameFromUrl = (url) => {
    if (!url) return '';
    try { return new URL(url, location.href).pathname.split('/').pop() || ''; }
    catch (e) { return String(url).split('?')[0].split('/').pop() || ''; }
  };

  const getMatchText = (el) => {
    const img = el.querySelector('img');
    if (!img) return '';
    const alt = img.getAttribute('alt') || '';
    let src = img.getAttribute('src') || img.currentSrc || '';
    if (!src) {
      const srcset = img.getAttribute('srcset') || '';
      src = srcset.split(',')[0].trim().split(' ')[0] || '';
    }
    const parts = stripDelim(alt) + '|' + stripDelim(filenameFromUrl(src));
    return parts === '|' ? '' : parts;
  };

  const getData = (gallery) => {
    let scope = gallery.parentElement;
    while (scope && scope !== document.body) {
      const el = scope.querySelector('script[id^="outdoer-variant-data-"]');
      if (el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
      scope = scope.parentElement;
    }
    const el = document.querySelector('script[id^="outdoer-variant-data-"]');
    if (el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
    return null;
  };

  const getCurrentVariantId = (gallery) => {
    const urlVid = new URLSearchParams(location.search).get('variant');
    if (urlVid) return urlVid;
    const section = gallery.closest('.shopify-section, section') || document;
    return (
      section.querySelector('form[action*="/cart/add"] [name="id"]')?.value ||
      section.querySelector('[name="id"]')?.value ||
      document.querySelector('form[action*="/cart/add"] [name="id"]')?.value ||
      document.querySelector('[name="id"]')?.value || ''
    );
  };

  const syncDots = (gallery) => {
    const slides = [...gallery.querySelectorAll('slideshow-slide')];
    if (!slides.length) return;
    const dots = [...gallery.querySelectorAll('button')].filter((b) => /^slide \d+ of \d+$/i.test((b.getAttribute('aria-label') || '').trim()));
    if (dots.length !== slides.length) return;
    slides.forEach((s, i) => {
      dots[i].style.display = s.style.display === 'none' ? 'none' : '';
    });
  };

  const applyToGallery = (gallery) => {
    const data = getData(gallery);
    if (!data) return;
    const allColorsNorm = (data.allColors || []).map(stripDelim).filter(Boolean);
    if (!allColorsNorm.length) return;
    if (allColorsNorm.length < 2) { gallery.setAttribute('data-outdoer-vg-ready', '1'); return; }

    const vid = getCurrentVariantId(gallery);
    const currentColor = stripDelim((data.variants || {})[vid] || '');

    const containers = [
      ...gallery.querySelectorAll('.product-media-container--image'),
      ...gallery.querySelectorAll('.dialog-thumbnails-list__thumbnail'),
    ];

    let anyCurrentMatch = false;
    const texts = containers.map((el) => {
      const txt = getMatchText(el);
      if (currentColor && txt && txt.includes(currentColor)) anyCurrentMatch = true;
      return txt;
    });

    const showAll = !currentColor || !anyCurrentMatch;

    containers.forEach((el, i) => {
      const txt = texts[i];
      let show = true;
      if (!showAll && txt) {
        if (txt.includes(currentColor)) {
          show = true;
        } else {
          show = !allColorsNorm.some((c) => c !== currentColor && txt.includes(c));
        }
      }
      if (show) {
        el.removeAttribute('data-outdoer-vg-hidden');
        el.style.display = '';
      } else {
        el.setAttribute('data-outdoer-vg-hidden', '1');
        el.style.display = 'none';
      }
    });
    syncDots(gallery);
    gallery.setAttribute('data-outdoer-vg-ready', '1');
  };

  const applyFilter = () => {
    document.querySelectorAll('media-gallery').forEach(applyToGallery);
  };

  let t = null;
  const debouncedApply = () => { clearTimeout(t); t = setTimeout(applyFilter, 50); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFilter, { once: true });
  } else {
    applyFilter();
  }

  document.addEventListener('load', (e) => {
    if (e.target && e.target.tagName === 'IMG' && e.target.closest && e.target.closest('media-gallery')) debouncedApply();
  }, true);

  window.addEventListener('load', debouncedApply);
  setTimeout(debouncedApply, 600);
  setTimeout(debouncedApply, 2000);

  const wrapHistory = (fn) => {
    const orig = history[fn];
    history[fn] = function () { const r = orig.apply(this, arguments); debouncedApply(); setTimeout(debouncedApply, 400); setTimeout(debouncedApply, 1200); return r; };
  };
  wrapHistory('pushState');
  wrapHistory('replaceState');
  window.addEventListener('popstate', debouncedApply);

  let lastVid = null;
  setInterval(() => {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    const vid = getCurrentVariantId(gallery);
    if (vid !== lastVid) { lastVid = vid; applyFilter(); }
  }, 400);

  document.addEventListener('change', (e) => { if (e.target && (e.target.name === 'id' || /variant_picker/.test(e.target.name || ''))) { debouncedApply(); setTimeout(debouncedApply, 500); } }, true);
  document.addEventListener('variantUpdate', debouncedApply);
  document.addEventListener('variant:change', debouncedApply);
  document.addEventListener('variant:changed', debouncedApply);

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      const t2 = m.target;
      if (t2 && t2.nodeType === 1 && (t2.closest ? (t2.closest('media-gallery') || t2.nodeName === 'MEDIA-GALLERY') : false)) { debouncedApply(); return; }
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.nodeName === 'MEDIA-GALLERY' || (n.querySelector && n.querySelector('media-gallery'))) { debouncedApply(); return; }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
